var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report-graphs-section"},[_c('recipients-report',{ref:"recipients",attrs:{"error":_vm.recipients.error,"graphData":_vm.recipients.data,"wrapperWidth":_vm.recipients.width},on:{"loadGraphData":_vm.loadGraphData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }